import React from 'react';
import { useContentBlockData } from 'hooks';
import { PreviewTextOverlay } from 'components/Shared';
const AboutCustomPreview = ({ active }) => {
    const { data } = useContentBlockData();
    if (!data)
        return null;
    return (React.createElement(PreviewTextOverlay, { active: active }, data.headline));
};
export default AboutCustomPreview;
